import { Injectable } from '@angular/core';
import { AngularFireAnalytics } from '@angular/fire/compat/analytics';
import { NavigationStart, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root',
})
export class GoogleEventsService {
  status: any;
  cartData: any = [];
  ProductData: any = [];
  businessData: any;
  tempData: any;
  deleteProductData: any = [];
  previousUrl: any;
  constructor(
    private analytics: AngularFireAnalytics,
    private store: Store<any>,
    private toastr: ToastrService,
    private router: Router
  ) {
    this.store
      .select((state) => state)
      .subscribe((data) => {
        this.cartData = data.cartReducer.cartData.products;
        this.businessData = data.authReducer.businessDetails;
        this.tempData = data.cartReducer.cartData;
      });
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.previousUrl = this.router.url;
      }
    });
  }

  getPreviousUrl() {
    return this.previousUrl;
  }

  googleEvent(action, category, label, index, value) {
    this.status = localStorage.getItem('status');
    if (this.status == 'allow') {
      this.analytics.logEvent(action, {
        category: category,
        label: label,
        index: index,
        value: value,
      });
    } else {
      console.log('The Google Analytics Cannot Be Accessed');
      
    }
  }

  // statusValue(value) {
  //   if (value) {
  //     this.status = value;
  //   }
  // }
  productdata() {
    this.ProductData = [];
    this.cartData.map((arr1, index) => {
      this.ProductData.push({
        item_id: arr1.product.material_number,
        item_name: arr1.product.material_description || '',
        //coupon: '',
        currency: this.businessData.currency,
        //discount: 0,
        item_brand: this.businessData.opco_data.name,
        item_category: 'Cement',
        item_list_id: index,
        item_list_name: this.tempData.inco_term,
        price: parseFloat(
          arr1?.total != null && !isNaN(arr1?.total) ? arr1?.total : '0'
        ),
        quantity: arr1?.inputValue,
      });
    });

    let itemData = {
      item_list_name: this.tempData.inco_term,
      items: this.ProductData,
    };

    console.log(itemData);
    return itemData;
  }
  deletedata() {
    this.deleteProductData = [];
    let itemData = {
      item_list_name: this.tempData.inco_term,
      items: this.deleteProductData,
    };
    this.tempData.products.map((arr1, index) => {
      this.deleteProductData.push({
        item_id: arr1.product.material_number,
        item_name: arr1.product.material_description || '',
        //coupon: '',
        currency: this.businessData.currency,
        //discount: 0,
        item_brand: this.businessData.opco_data.name,
        item_category: 'Cement',
        item_list_id: index,
        item_list_name: this.tempData.inco_term,
        price: parseFloat(
          arr1?.total != null && !isNaN(arr1?.total) ? arr1?.total : '0'
        ),
        quantity: arr1?.inputValue,
      });
    });
    return itemData;
  }
}
